export default function DeliverySkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <div className="h-28 w-full animate-pulse bg-gray-100" />
      <div className="h-28 w-full animate-pulse bg-gray-100" />
      <div className="h-28 w-full animate-pulse bg-gray-100" />
      <div className="h-28 w-full animate-pulse bg-gray-100" />
    </div>
  );
}
